import { Link } from 'react-router-dom';
import { worksData } from '../../../mocks/works';

const WorksSection = () => {
  const featuredWorks = worksData.slice(0, 3);

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="px-4 md:px-8 lg:px-16">
        <div className="flex items-end justify-between mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
            制作実績
          </h2>
          <Link
            to="/works"
            className="text-primary font-bold hover:text-primary-dark transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            すべて見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featuredWorks.map((work) => (
            <article
              key={work.id}
              className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img
                  src={work.image}
                  alt={work.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <span className="absolute bottom-4 left-4 px-3 py-1 bg-white text-primary text-xs font-bold rounded-full shadow-lg">
                  {work.category}
                </span>
              </div>
              <div className="p-6">
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2">
                  {work.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed line-clamp-2">
                  {work.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorksSection;
